// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"colorPrimary-3lsnj"};